(function() {
  var STAR_PATH = 'M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z';

  function buildStar(fill) {
    return '<svg class="pdp-star-icon" viewBox="0 0 576 512" width="16" height="16"><path d="' + STAR_PATH + '" fill="' + fill + '"/></svg>';
  }

  function init() {
    var el = document.querySelector('.yotpo-bottom-line[average-score]');
    if (el) {
      var score = parseFloat(el.getAttribute('average-score'));
      var summary = document.querySelector('.yotpo-bottom-line-summary');
      if (summary) {
        var match = summary.textContent.match(/(\d+)\s*review/);
        if (match) {
          var count = parseInt(match[1]);
          var container = document.getElementById('pdp-star-rating');
          if (container) {
            var starsEl = container.querySelector('.pdp-star-rating__stars');
            var scoreEl = container.querySelector('.pdp-star-rating__score');
            var countEl = container.querySelector('.pdp-star-rating__count');
            var html = '';
            var full = Math.floor(score);
            var decimal = score - full;
            for (var i = 0; i < full; i++) {
              html += buildStar('#333');
            }
            if (decimal > 0 && full < 5) {
              var pct = (decimal * 100).toFixed(0);
              html += '<svg class="pdp-star-icon" viewBox="0 0 576 512" width="16" height="16">'
                + '<defs><linearGradient id="pdp-partial"><stop offset="' + pct + '%" stop-color="#333"/><stop offset="' + pct + '%" stop-color="#ddd"/></linearGradient></defs>'
                + '<path d="' + STAR_PATH + '" fill="url(#pdp-partial)"/></svg>';
              full++;
            }
            for (var j = full; j < 5; j++) {
              html += buildStar('#ddd');
            }
            starsEl.innerHTML = html;
            scoreEl.textContent = score.toFixed(1) + '/5';
            countEl.textContent = '(' + count + ')';
            container.style.display = 'flex';
          }
        }
      }
    } else {
      setTimeout(init, 500);
    }
  }
  setTimeout(init, 1000);
})();
